<p-confirmDialog key="add" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Main Grid-->
<div class="MainGrid2Col">
	<!--INSERT CUSTOM POPUP FIELDS-->
	<label>Code:</label>
	<input class="form-control" type="text" placeholder="" [(ngModel)]="SchoolIncidentTypeCD" />

	<label>Description:</label>
	<input class="form-control" type="text" placeholder="" [(ngModel)]="SchoolIncidentTypeDesc" />
</div>

<!--Buttons-->
<div class="Buttons">
	<button class="btn btn-primary" (click)="onAddType()">Add</button>
	<button class="btn btn-primary" (click)="onClose()">Close</button>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
